import React from 'react'
import { Portal } from 'react-portal'

import { ParentAccessLevelDropdown } from '../ParentAccessLevelDropdown'
import { ShareForSettingsModal } from '../types'
import { ConfirmationDialog } from '@sketch/components'
import { capitalize } from '@sketch/utils'
import { useUpdateShareParentPermissions } from './useUpdateShareParentPermissions'
import { useGetWorkspaceMembershipsCountQuery } from '@sketch/gql-types'

interface ShareForWorkspacePermissions {
  share: Pick<
    ShareForSettingsModal,
    | 'identifier'
    | 'userCanUpdateSettings'
    | 'parentAccessLevel'
    | 'type'
    | 'allowedParentAccessLevels'
    | 'isDraft'
    | 'workspace'
    | 'name'
  >
}

const WorkspacePermissions = ({ share }: ShareForWorkspacePermissions) => {
  const { data } = useGetWorkspaceMembershipsCountQuery({
    variables: { workspaceId: share.workspace.identifier },
  })

  const {
    getUpdateShareParentPermissionsConfirmDialogProps,
    getUpdateShareParentPermissionsDropdownProps,
    updateShareParentPermissionsConfirmDialogOpen,
    shareParentAccessLevel,
  } = useUpdateShareParentPermissions({ share })

  const totalMemberships =
    data?.workspace.memberships.totalMemberships?.meta.totalCount || 0
  const totalGuests =
    data?.workspace.memberships.totalGuests?.meta.totalCount || 0

  const workspaceMembersCount = totalMemberships - totalGuests

  return (
    <>
      <ParentAccessLevelDropdown
        share={share}
        workspaceMembersCount={workspaceMembersCount}
        {...getUpdateShareParentPermissionsDropdownProps()}
      />
      {updateShareParentPermissionsConfirmDialogOpen && (
        <Portal>
          <ConfirmationDialog
            {...getUpdateShareParentPermissionsConfirmDialogProps()}
            title={`Change Workspace Access to ${capitalize(
              shareParentAccessLevel
            )}?`}
            confirmButton={{ text: 'Change Access', variant: 'negative' }}
          >
            You’ll no longer be able to edit “{share.name}”. To get edit access
            again, ask an Admin or somebody with edit access to add you.
          </ConfirmationDialog>
        </Portal>
      )}
    </>
  )
}

export { WorkspacePermissions }
